
/**
 * Common utilities and constants for RTM AI Analytics Dashboards
 */

export const COLORS = {
  // Status Colors
  DONE: "#4caf50",
  RESOLVED: "#4caf50",
  CLOSED: "#4caf50",
  IN_PROGRESS: "#2196f3",
  TO_DO: "#ff9800",
  OPEN: "#2196f3",
  FAIL: "#f44336",
  PASS: "#4caf50",
  BLOCKED: "#ff9800",
  UNEXECUTED: "#9e9e9e",
  
  // Priority Colors
  CRITICAL: "#d32f2f",
  HIGH: "#f44336",
  MEDIUM: "#ff9800",
  LOW: "#4caf50",
  
  // Theme Colors
  PRIMARY: "#1a237e",
  SECONDARY: "#673ab7",
  LIGHT_BG: "#f5f7fa",
  BORDER: "#e0e0e0",
  
  // Chart Palette
  PALETTE: [
    "#4caf50",
    "#2196f3",
    "#ff9800",
    "#9e9e9e",
    "#673ab7",
    "#00bcd4",
    "#e91e63",
    "#3f51b5",
  ]
};

export const SCROLLBAR_STYLES = {
  "&::-webkit-scrollbar": {
    width: "6px",
    height: "6px",
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "#f1f1f1",
    borderRadius: "10px",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#c1c1c1",
    borderRadius: "10px",
    "&:hover": {
      backgroundColor: "#a8a8a8",
    },
  },
  scrollbarWidth: "thin",
  scrollbarColor: "#c1c1c1 #f1f1f1",
};

/**
 * Finds a key in an object by partial case-insensitive match
 */
export const findKey = (dataRow, pattern) => {
  if (!dataRow) return "";
  return (
    Object.keys(dataRow).find((k) =>
      k.toLowerCase().includes(pattern.toLowerCase()),
    ) || ""
  );
};

/**
 * Formats a date string to a consistent display format
 */
export const formatDate = (dateStr) => {
  if (!dateStr) return "N/A";
  try {
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return dateStr;
    return d.toLocaleDateString("en-US", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  } catch (e) {
    return dateStr;
  }
};

/**
 * Handles the display logic for multi-select filter values
 */
export const renderFilterValue = (selected) => {
  if (!selected || selected.length === 0 || selected.includes("All")) return "All";
  if (selected.length === 1) return selected[0];
  return `${selected[0]} +${selected.length - 1}`;
};

/**
 * Standard menu props for MUI Select
 */
export const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: 300,
      width: 250,
    },
  },
};
